module.exports = __webpack_public_path__ + "static/media/chinabank.850023f5.svg";